module.exports = __webpack_public_path__ + "static/img/BK8.4d434e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/order/BK8.png
// module id = b60f
// module chunks = 9